// import axios from '@/utils/axiosDocker';
import axios from '@/services/apiAxios'

import queryString from '@/utils/queryString';


export default {
    namespaced: true,
    state: {
        status: []
    },
    mutations: {
        setStatus(state, payload) {
            state.status = state.status.concat(payload);
        }
    },
    // state: {
    //     journalVoucher: null,
    //     journalVouchers: [],
    //     status: null
    // },
    // mutations: {
    //     setJournalVoucher(state, payload) {
    //         state.journalVoucher = payload;
    //     },
    //     setJournalVouchers(state, payload) {
    //         state.journalVouchers = payload;
    //     }
    // }, 
    actions: {
        storeJournalVoucher({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url:`journal/journal-voucher`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        updateJournalVoucher({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `journal/journal-voucher/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removeJournalVoucher({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `journal/journal-voucher/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removeJournalEntries({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `journal/journal-voucher`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        fetchJournalVoucher({ rootState, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `journal/journal-voucher/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                } 
                );
            })
        },
        fetchJournalVouchers({ rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `journal/journal-voucher?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        },
        postJournalVoucher({ rootState, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: 'post',
                    url: `journal/journal-voucher/${payload}/post`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error) 
                })
            })
        },
        reverseJournalVoucher({ rootState, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: 'put',
                    url: `journal/journal-voucher/${payload}/reverse`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error) 
                })
            })
        },
        getJournalVoucherStatus({ commit , rootState, dispatch }) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: 'get',
                    url: `journal/journal-voucher-status`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    commit('setStatus', response.data);
                    resolve(response)
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error) 
                })
            })
        },
    }
}